// eslint-disable import/no-cycle
import request from '@/utils/request'

/** ------------------------*待租*---------------------------* */
// 自定义标签查询
export function getTenantCustomTagList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}

// ---------------------------企业租赁订单---------------------
// 列表tab及对应数量
export function getLeaseOrderSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/summary',
    method: 'POST',
    data,
  })
}

// 主订单列表
export function getLeaseOrderList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/list',
    method: 'POST',
    data,
  })
}

// 详情
export function getLeaseDetail(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/detail',
    method: 'post',
    data,
  })
}

// 保存
export function doLeaseOrderEdit(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/edit',
    method: 'post',
    data,
  })
}

// 新增租赁车辆
export function addleaseOrderCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add/car',
    method: 'POST',
    data,
    bizCode: [22049],
  })
}

// 新增企业租赁订单
export function AddleaseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add',
    method: 'POST',
    data,
  })
}

// 批量添加车辆
export function leaseOrderCarImport(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/car/import',
    method: 'POST',
    data,
  })
}


// ----------------------------------企业租赁子订单详情--------------------------------
// 订单详情
export function leaseContractOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/detail',
    method: 'POST',
    data,
  })
}

// 脱敏个人订单详情
export function getPersonalOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/detail/sensitive',
    method: 'POST',
    data,
  })
}


// -------------------------------个人租赁订单-----------------------------------------
// 列表
export function PurchaseAndSeven(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/list',
    method: 'post',
    data,
  })
}

// 列表tab及对应数量
export function TabListSeven(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/summary',
    method: 'post',
    data,
  })
}

// --------------------------订单操作------------------------------

// 企业租赁-订单关闭
export function closeEnterpriseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/close',
    method: 'POST',
    data,
  })
}

// 放弃退车
export function SureGiveup(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/cancelReturnCar',
    method: 'POST',
    data,
  })
}

// 开启网约钱包线上代扣
export function openWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/open',
    method: 'POST',
    data,
  })
}

// 解约网约钱包支付
export function breakWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/break',
    method: 'POST',
    data,
  })
}

// 撤销网约钱包支付通知
export function cancelWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/cancel',
    method: 'POST',
    data,
  })
}

// 撤回解约网约钱包支付
export function revokeTerminateWalletWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/break/revoke',
    method: 'POST',
    data,
  })
}

// 开启支付宝线上代扣
export function openAlipayWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/alipayWithhold/open',
    method: 'POST',
    data,
  })
}

// 解约支付宝支付
export function terminateAlipayWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/alipayWithhold/terminate',
    method: 'POST',
    data,
  })
}

// 撤回解约支付宝支付
export function revokeTerminateAlipayWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/alipayWithhold/terminate/revoke',
    method: 'POST',
    data,
  })
}


// 发起退车
export function initiateVehicle(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/close',
    method: 'POST',
    data,
  })
}

// ------------------------------租赁方案管理------------------------------------
// 列表
export function getLeasingSchemeConfigList(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/list',
    method: 'POST',
    data,
  })
}

// ---------------------------------采购订单--------------------------------------------
// 子订单详情
export function getSubOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/detail',
    method: 'post',
    data,
  })
}


// --------------------------------------------租赁方案----------------------------------
// 订单详情-支付计划
export function getDetailAccruedInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/detailAccruedInfo',
    method: 'POST',
    data,
  })
}

// 支付计划-查看应收单详情
export function paymentDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/payment/detail',
    method: 'post',
    data,
  })
}

/**
 * 获取租赁方案详情
 * @deprecated
 * 请使用 `getLeasePlanDetails`
 */
export function getLeasingSchemeConfigDetail(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/detail',
    method: 'POST',
    data,
  })
}

// 获取租赁方案上下架列表
export function getLeasingSchemeConfigRecordList(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/record/list',
    method: 'POST',
    data,
  })
}

// 租赁方案列表
export function planList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/plan/detail',
    method: 'post',
    data,
  })
}

// 订单关联信息
export function relationList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/relationList',
    method: 'POST',
    data,
  })
}

// 合同签署记录 (e签宝线上合同签署记录)
export function contractSigning(data) {
  return request({
    url: '/admin/v1/vehicle/contract2/record/list',
    method: 'POST',
    data,
  })
}

// 代扣日志查询接口
export function withholdLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/withhold/log/list',
    method: 'POST',
    data,
  })
}

// 个人租赁保存当前核算方案
export function addSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/addSettlement',
    method: 'POST',
    data,
  })
}

/*
  采销合同新增页——保存
  {
  "carId": 111, // 车辆ID
  "signDate": "yyyy-MM-dd", // 签署日期
  "effectDate": "yyyy-MM-dd", // 合同开始时间
  "endDate": "yyyy-MM-dd", // 合同结束时间
  "customerId": 1111, // 承租方ID
  "customerType": 1, // 承租方类型 1个人/2企业
  "customerName": "xxx", // 承租方名称
  "contactTel": "18888888888", // 联系方式
  "payForm": 1, // 支付形式   1一次性付租金/2分期付租金
  "totalRent": "10000", // 租金总金额
  "deposit": "1000", // 一次性收取押金
  "manageFee": "1000", // 一次性收取管理费
  "serviceFee": "1000", // 一次性收取服务费
  "rentPerPeriod": "1000", // 每期租金
  "payType": 1, // 支付类型  1月付预付/2月付后付
  "billingDate": "10", // 款项生成日
  "payPlans": [ // 支付计划
    {
      "payContent": 1, // 支付内容 1租金/2押金/3管理费/4服务费/5维保费用/6出险费用/7违章代办/8油费/9违约金/10车损/11免佣/100其他
      "dueDate": "yyyy-MM-dd", // 应收日期
      "payCycle": "2021/11/01-2021/11-30", // 款项周期
      "cycleDays": 30, // 周期天数
      "dueAmount": "1000", // 应收金额
      "remarks": "xxx", // 备注
    }
  ]
}
*/

// 个人租赁订单确认并提交财务核算
export function confirmSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/confirmSettlement',
    method: 'POST',
    data,
  })
}

// 根据退车交接时间 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
export function calculateReceivableAmount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/calculateReceivableAmount',
    method: 'POST',
    data,
  })
}

// 租赁订单发起合同签约
export function leaseOrderStartSign(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/startSign',
    method: 'POST',
    data,
  })
}

// 租赁订单作废合同签约
export function leaseOrderInvalidSign(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/invalid',
    method: 'POST',
    data,
  })
}

// 租赁订单撤销合同签约
export function leaseOrderCancelSign(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/cancel',
    method: 'POST',
    data,
  })
}

// 租赁合同里的确认订单
export function leaseContractOrderConfirm(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/confirm',
    method: 'POST',
    data,
  })
}

// 新确认订单接口 https://mock-test.cheweijia.com/project/10282/interface/api/492807
export function confirmContract({
  orderId, // 订单id，必须
  isWithhold, // 是否代扣，必须
  isWalletWithhold, // 是否网约代扣，必须
  isAlipayWithhold, // 是否支付宝支付，必须
  licenceNo, // 签约主体，必须
  templateId, // 合同模板id
  signChannel, // 签署渠道，1线下，2线上
  attachment, // 附件
  customerId,
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/order/confirmNew',
    method: 'POST',
    data: {
      orderId,
      isWithhold,
      isWalletWithhold,
      isAlipayWithhold,
      licenceNo,
      templateId,
      signChannel,
      attachment,
      customerId,
    },
  })
}

// 获取应收单详情
export function getDetailReceivable(data) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/detailReceivable',
    method: 'POST',
    data,
  })
}


// 个人租赁订单详情 + 相关事故、维保状态、违章状态 数量
export function orderDetailAndMore(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/modeConversion/detail',
    method: 'POST',
    data,
  })
}
/** ----------------------------- *司机履约风控*-----------------------------* */
// 风控列表
export function getRiskList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/risk/record/list',
    method: 'POST',
    data,
  })
}
// 风控详情
export function getRiskDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/risk/record/detail',
    method: 'POST',
    data,
  })
}
// 风控配置编辑
export function recordConfigEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/risk/record/config/edit',
    method: 'POST',
    data,
  })
}
// 风控配置详情
export function recordConfigDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/risk/record/config/detail',
    method: 'POST',
    data,
  })
}
// 风控变更记录列表
export function modifyRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/risk/modify/record/list',
    method: 'POST',
    data,
  })
}
// 风控跟进记录列表
export function followList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/debt/follow/list',
    method: 'POST',
    data,
  })
}
// 异步导出司机风控预警
export function exportRisk(data = {}) {
  return request({
    url: '/admin/v1/vehicle/risk/record/export',
    method: 'post',
    data,
  })
}
/** ----------------------------- *逾期催收*-----------------------------* */

/* 逾期汇总表 - 列表 */
export function getOverDueSummaryList(data) {
  return request({
    // url: '/mock/852/admin/v1/vehicle/debt/getOverDueSummary',
    url: '/admin/v1/vehicle/debt/getOverDueSummary',
    method: 'POST',
    data,
  })
}

/* 逾期汇总表 - 金额统计 */
export function amountSummary(data) {
  return request({
    // url: '/mock/852/admin/v1/vehicle/debt/summary/amountSummary',
    url: '/admin/v1/vehicle/debt/summary/amountSummary',
    method: 'POST',
    data,
  })
}
/* 逾期汇总表 - 汇总详细 (企业/个人) */
export function detailOverDue(data) {
  return request({
    url: '/admin/v1/vehicle/debt/detailOverDue',
    method: 'POST',
    data,
  })
}

/* 逾期汇总表 - 汇总详细 - 统计 */
export function receivableSummary(data) {
  return request({
    url: '/admin/v1/vehicle/debt/summary/receivableSummary',
    method: 'POST',
    data,
  })
}
/* 催租 - 预提醒明细表 - 列表 */
export function getRemindItems(data) {
  return request({
    url: '/admin/v1/vehicle/debt/getRemindItems',
    method: 'POST',
    data,
  })
}
/* 催租 - 逾期明细表 - 列表 */
export function getOverDueItems(data) {
  return request({
    url: '/admin/v1/vehicle/debt/getOverDueItems',
    method: 'POST',
    data,
  })
}
/* 催租 - 逾期明细异步导出 */
export function asyncOverdueExport(data) {
  return request({
    url: '/admin/v1/vehicle/debt/overdue/export',
    method: 'POST',
    data,
  })
}
/* 催租 - 逾期配置 - 详情 */
export function overdueConfigDetail(data) {
  return request({
    url: '/admin/v1/vehicle/hastenDebt/overdueConfig/getDetail',
    method: 'POST',
    data,
  })
}
/* 催租 - 逾期配置 - 保存 */
export function overdueConfigSave(data) {
  return request({
    url: '/admin/v1/vehicle/hastenDebt/overdueConfig/save',
    method: 'POST',
    data,
  })
}
/* 催租 - 异步任务列表（导出） */
/*
  @taskType(任务类型): 1-逾期明细 2-风控记录 3-车辆运营 4-客户运营
*/
export function asyncExportList(data) {
  return request({
    url: '/admin/v1/vehicle/async/export/list',
    method: 'POST',
    data,
  })
}
/* 催租 - 添加跟进记录 */
export function addFollow(data) {
  return request({
    url: '/admin/v1/vehicle/debt/follow/add',
    method: 'POST',
    data,
  })
}
/* 催租 - 逾期单详情 */
export function overdueDetail(data) {
  return request({
    url: '/admin/v1/vehicle/debt/overdue/detail',
    method: 'POST',
    data,
  })
}

// 撤回审批
export function withdrawApproval(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/revoke',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 收款单收款方式
 * @apiUrl
 */
export function getCollectionPayMethod(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/type',
    method: 'POST',
    data,
  })
}
// 获取应收款项列表
export function getCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/batchSelect',
    method: 'POST',
    data,
  })
}

// 获取关联合同记录列表
export function getContractList(data) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/list',
    method: 'post',
    data,
  })
}

// 关联合同统计查询
export function getRelationTypeList(data) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/summary',
    method: 'post',
    data,
  })
}

// 提前发车
export function skipPayment(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/skip/payment',
    method: 'post',
    data,
  })
}

// 查询合同签署状态
export function queryContractState(data) {
  return request({
    url: '/admin/v1/vehicle/contract/record/queryContractState',
    method: 'post',
    data,
  })
}

// 退车周期金额预览
export function previewSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/previewSettlement',
    method: 'post',
    data,
  })
}

// 生成支付计划
export function getPreviewedPlan(data) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/getPreviewedPlan',
    method: 'post',
    data,
  })
}

// 获取支付计划汇总数据
export function getAccruedPlanStatistic(data) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/getAccruedPlanStatistic',
    method: 'post',
    data,
  })
}


// 金额校验
export function orderAccruedplanvalidAccruedPlanAmountApi(data) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/validAccruedPlanAmount',
    method: 'post',
    data,
  })
}
/* ---销售线索管理API---Start--- */

/**
 * 销售线索修改姓名 resourceKey=rent_car_clue_update
 * @id 线索ID
 * @name
 */
export function resetSalesLeadName(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/update',
    method: 'POST',
    data,
  })
}

/**
 * 销售线索状态统计接口 resourceKey=rent_car_clue_stat
 * enum allNum 全部 toFollowNum 待跟进 followingNum 跟进中 orderedNum 已下单 pickedNum 已提车 invalidNum 无效
 */
export function getSalesLeadStatusCount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/stat',
    method: 'POST',
    data,
  })
}

/**
 * 销售线索列表查询接口 resourceKey=rent_car_clue_list
 * {
  "pageNum": 0, // 当前页数
  "pageSize": 0, // 每页数据量
  "id": 0, // 线索ID
  "storeId": 0, // 门店ID
  "name": "", // 姓名
  "phone": "", // 手机号
  "adcode": "", // 城市
  "channel": "", // 线索渠道
  "label": "", // 线索标签
  "gmtCreateStart": "", // 创建开始时间
  "gmtCreateEnd": "" // 创建结束时间
}
 */
export function getSalesLeadList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/list',
    method: 'POST',
    data,
  })
}
/**
 * 销售线索跟进接口 resourceKey=rent_car_clue_sales_follow
 * @clueId 线索ID
 * @orderId 订单ID
 * @followTime 跟进时间
 * @clueState 线索状态
 * @label 线索标签
 * @followRemarks 跟进记录
 * @nextFollowTime 下次跟进时间
 */
export function followSalesLead(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/follow',
    method: 'POST',
    data,
  })
}

/**
 * 销售线索详情接口 resourceKey=rent_car_clue_sales_detail
 * @id 线索ID
 */
export function getSalesLeadDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/detail',
    method: 'POST',
    data,
  })
}

/**
 * 销售线索门店列表查询接口 resourceKey=rent_car_clue_store_list
 */
export function getSalesLeadStoreList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/store/list',
    method: 'POST',
    data,
  })
}
/**
 * 销售线索门店列表查询接口 resourceKey=rent_car_clue_city_list
 */
export function getSalesLeadCityList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/city/list',
    method: 'POST',
    data,
  })
}

/**
 * 销售线索渠道列表查询接口 resourceKey=rent_car_clue_channel_list
 */
export function getSalesLeadChannelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/channel/list',
    method: 'POST',
    data,
  })
}

/* ---销售线索管理API---End--- */

// 修改订单中的司管信息
export function modifyDriverManager(orderId, managerId) {
  return request({
    url: '/admin/v1/vehicle/rent/order/manager/edit',
    method: 'POST',
    data: {
      orderId,
      managerId,
    },
  })
}

// 订单修改司管前检查
export function checkDriverManagerByOrder(orderId, managerId) {
  return request({
    url: '/admin/v1/vehicle/rent/order/manager/checkBeforeEdit',
    method: 'POST',
    data: {
      orderId,
      managerId,
    },
  })
}

// 订单核算详情
export function getOrderAccount(data) {
  return request({
    url: '/admin/v1/vehicle/order/account/detail',
    method: 'post',
    data,
  })
}

// 订单核算详情
export function getOrderAccountSensitive(data) {
  return request({
    url: '/admin/v1/vehicle/order/account/detail/sensitive',
    method: 'post',
    data,
  })
}

// 订单核算结果预览
export function previewOrderAccount(data) {
  return request({
    url: '/admin/v1/vehicle/order/account/preview',
    method: 'post',
    data,
  })
}

// 保存订单核算单
export function saveOrderAccount(data) {
  return request({
    url: '/admin/v1/vehicle/order/account/save',
    method: 'post',
    data,
  })
}

// 提交订单核算单
export function submitOrderAccount(data) {
  return request({
    url: '/admin/v1/vehicle/order/account/confirm',
    method: 'post',
    data,
  })
}

// 获取退车核算单状态
export function getOrderAccountState(data) {
  return request({
    url: '/admin/v1/vehicle/order/account/getByOrderId',
    method: 'post',
    data,
  })
}

// 查询渠道名称列表
// https://mock-test.cheweijia.com/project/10282/interface/api/491585
export function getClueChannelNameList(data) {
  return request({
    url: '/admin/v1/vehicle/clueChannel/name/list',
    method: 'post',
    data,
  })
}

// 新增线索渠道
// https://mock-test.cheweijia.com/project/10282/interface/api/491557
export function saveClueChannel(data) {
  return request({
    url: '/admin/v1/vehicle/clueChannel/save',
    method: 'post',
    data,
  })
}

// 查询线索渠道列表
// https://mock-test.cheweijia.com/project/10282/interface/api/491561
export function getClueChannelList(data) {
  return request({
    url: '/admin/v1/vehicle/clueChannel/page',
    method: 'post',
    data,
  })
}

// 启用/禁用线索渠道
// https://mock-test.cheweijia.com/project/10282/interface/api/491583
export function changeClueChannelState(data) {
  return request({
    url: '/admin/v1/vehicle/clueChannel/updateState',
    method: 'post',
    data,
  })
}

// 编辑线索渠道
// https://mock-test.cheweijia.com/project/10282/interface/api/491559
export function updateClueChannel(data) {
  return request({
    url: '/admin/v1/vehicle/clueChannel/update',
    method: 'post',
    data,
  })
}

// 新建线索
// https://mock-test.cheweijia.com/project/10282/interface/api/491595
export function saveNewClue(data) {
  return request({
    url: '/admin/v1/vehicle/clue/save',
    method: 'post',
    data,
  })
}

// 司机申诉管理列表
export function getComplaintManageList(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/withhold/appeal/list',
    method: 'post',
    data,
  })
}

// 司机申诉处理
export function handleComplaint(data) {
  return request({
    url: '/admin/v1/vehicle/withhold/appeal/deal',
    method: 'post',
    data,
  })
}

// 手机号码密文转换
export function getPhoneNumber(data) {
  return request({
    url: '/admin/v1/vehicle/withhold/appeal/checkPhone',
    method: 'post',
    data,
  })
}

// 获取租赁方案配置 https://mock-test.cheweijia.com/project/10282/interface/api/492365
export function getRentPlanConfig({
  planId, // 方案ID
  startDate, // 开始日期
  depositTransfer, // 续约单是否转移押金 0-不转 1-转
  oldOrderId, // 续约单的原单id
  productSnapshotId, // 商品快照
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/order/initConfig',
    method: 'post',
    data: {
      planId,
      startDate,
      depositTransfer,
      oldOrderId,
      productSnapshotId,
    },
  })
}


// 个人租赁订单订单详情-公共信息部分
export function orderDetailCommonInfoV2(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/orderDetailCommonInfoV2',
    method: 'post',
    data,
  })
}

// 个人租赁-订单详情tab
export function orderDetailInfoV2(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/orderDetailInfoV2',
    method: 'post',
    data,
  })
}

// 司机账单-租金规则
export function dynamicRentRuleInfo(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/dynamicRentRuleInfo',
    method: 'post',
    data,
  })
}

// 司机账单-列表
export function orderDriverBillInfo(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/orderDriverBillInfo',
    method: 'post',
    data,
  })
}

// 司机账单-汇总
export function orderDriverBillSummary(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/orderDriverBillSummaryInfo',
    method: 'post',
    data,
  })
}

// 司机账单-收款详情
export function orderReceivableInfo(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/orderReceivableInfo',
    method: 'post',
    data,
  })
}

// 租赁方案下架前置检查
export function disableRentVerification(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/disableVerification',
    method: 'post',
    data,
  })
}

// 租赁方案-押金分期校验逻辑
export function depositInstallmentCheck(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/depositInstallmentCheck',
    method: 'post',
    data,
  })
}

export function queryValidAlipayMerchantList(data) {
  return request({
    url: '/admin/v1/vehicle/alipay/queryValidAlipayMerchantList',
    method: 'post',
    data,
  })
}

// 结算汇总信息
export function getSettlementSummary(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/driver/cooperation/settlementSummaryInfo',
    method: 'post',
    data,
  })
}

// 结算记录列表
export function getSettlementRecord(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/driver/cooperation/settlementRecordList',
    method: 'post',
    data,
  })
}

// 租金温馨提示
export function checkRentAmount(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/order/payPlan/rentAmountCheck',
    method: 'post',
    data,
  })
}

// 结算计划预览
export function payPlanPreview(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/order/payPlan/preview',
    method: 'post',
    data,
  })
}

// 结算计划统计
export function payPlanStatistics(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/order/payPlan/statistic',
    method: 'post',
    data,
  })
}

// 获取订单详情车辆列表
export function getOrderCarList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/carDetail',
    method: 'post',
    data,
  })
}

// 获取订单详情应付列表
export function getOrderPaymentList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/paymentDetail',
    method: 'post',
    data,
  })
}

// 获取订单应收列表
export function getOrderReceivableList(data) {
  return request({
    url: '/admin/v1/vehicle/lease/order/receivableDetail',
    method: 'post',
    data,
  })
}

// 租赁签署流程状态
export function getLeaseSignProcessStatus(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/rent/queryState',
    method: 'post',
    data,
  })
}

// 租赁签署流程配置
export function getLeaseSignProcessConfig(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/rent/queryConfig',
    method: 'post',
    data,
  })
}

// 合作网约平台列表
export function getCooperationPlatformList(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/wallet/sp/list',
    method: 'post',
    data,
  })
}

// 生成签署二维码
export function genSignQrCode(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/rent/signCheck/genQrCode',
    method: 'post',
    data,
    signParams: ['orderId', 'payMethods[0]', 'spId'],
  })
}

// 撤回审批
export function revokeApproval(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/rent/revokeApproval',
    method: 'post',
    data,
  })
}

// 撤回签署
export function revokeSign(data) {
  return request({
    url: '/admin/v1/vehicle/signFlow/rent/cancel',
    method: 'post',
    data,
  })
}

// 批量收款
export function batchReceivablePayment(data) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/batchPayment',
    method: 'post',
    data,
    bizCode: [35107],
  })
}

// 网约钱包签署流程(网约钱包)
export function queryWalletSignFlowState(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/wallet/queryState',
    method: 'post',
    data,
  })
}


// 网约钱包签署流程配置(网约钱包)
export function queryWalletSignFlowConfig(data) {
  return request({
    url: '/admin/v1/vehicle/signFlow/wallet/queryConfig',
    method: 'post',
    data,
  })
}

// 生成签署二维码(网约钱包)
export function genWalletSignQrcode(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/wallet/signCheck/genQrCode',
    method: 'post',
    data,
    signParams: ['orderId', 'feeTypeAndAmountList[0].feeAmount', 'spId'],
  })
}

// 撤回签署(网约钱包)
export function withdrawWalletSign(data) {
  return request({
    url: '/admin/v1/vehicle/signFlow/wallet/cancel',
    method: 'post',
    data,
  })
}

// 推送司机端
export function sendToDriverApp(data) {
  return request({
    url: '/admin/v1/vehicle/signFlow/wallet/sendToChannel',
    method: 'post',
    data,
  })
}


// 支付宝签署流程状态(订单详情)
export function queryAlipaySignStatus(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/alipay/queryState',
    method: 'post',
    data,
  })
}

// 支付宝签署流程配置
export function queryAlipaySignConfig(data) {
  return request({
    url: '/admin/v1/vehicle/signFlow/alipay/queryConfig',
    method: 'post',
    data,
  })
}

// 生成签署二维码(支付宝)
export function genAlipaySignQrCode(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/signFlow/alipay/signCheck/genQrCode',
    method: 'post',
    data,
    signParams: ['orderId', 'feeTypeAndAmountList[0].feeAmount'],
  })
}

// 撤回签署(支付宝)
export function withdrawAlipaySign(data) {
  return request({
    url: '/admin/v1/vehicle/signFlow/alipay/cancel',
    method: 'post',
    data,
  })
}

/**
 * 个人租赁订单（包含续约单）创建时，计算合同结束日期
 * @param {string} data.startDate 租赁起始日期 格式yyyy-MM-dd
 * @param {number} data.rentPeriodType 租期类型 1-日/2-周/3-月
 * @param {number} data.rentPeriod 租期数
 * @param {number} data.presentDays 赠送天数
 * @returns {string} data.endData 结束日期
 */
export function calculateContractEndData(data = {}) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/calculateContractEndData',
    method: 'post',
    data,
  })
}


/**
 * 计算两个日期之间的天数差
 */
export function calculateDays(data = {}) {
  return request({
    url: '/admin/v1/vehicle/orderAccrued/plan/calculateDays',
    method: 'post',
    data,
  })
}

/**
 * 创建订单时检查租赁方案是否有变更
 * @param {*} data 同租赁方案新增
 * @returns {string} data.planName 租赁方案名称
 * @returns {boolean} data.isChange 是否有变更 true-有变更 false-无变更
 */
export function checkPlanChange(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/checkPlanChange',
    method: 'post',
    data,
  })
}

/**
 * @typedef {Object} OrderMobileData
 * @property {number} customerId 客户ID
 * @property {number} rentOrderId 订单ID
 * @property {string} userMobile 下单手机号
 */

/**
 * 查询下单手机号
 * @param {Object} data
 * @param {number} data.rentOrderId 订单ID
 * @param {number} data.customerId 客户ID
 * @returns {Promise<APIResponse<OrderMobileData>>}
 */
export function getOrderMobile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/queryUserMobile',
    method: 'POST',
    data,
  })
}

// 提车成功详情
export function getSuccessDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/successDetail',
    method: 'POST',
    data,
  })
}
